import {NgModule} from '@angular/core';
import {CustomerSelectionService} from '@presentation/pages/texfab/customer/customer-selection.service';
import {CustomerOverviewService} from '@presentation/pages/texfab/customer/overview/customer-overview.service';
import {ColorSelectionService} from '../color/color-selection.service';
import {ColorOverviewService} from '../color/overview/color-overview.service';
import {MaterialOverviewService} from '../raw-material/material-overview.service';
import {MaterialSelectionService} from '../raw-material/material-selection.service';
import {PlasticProductGroupOverviewService} from './add/plastic-product-group-overview.service';
import {PlasticProductGroupSelectionService} from './add/plastic-product-group-selection.service';

@NgModule({
  providers: [
    PlasticProductGroupOverviewService,
    PlasticProductGroupSelectionService,
    MaterialOverviewService,
    MaterialSelectionService,
    ColorOverviewService,
    ColorSelectionService,
    CustomerOverviewService,
    CustomerSelectionService
  ]
})
export class PlasticProductSelectionModule {}
